import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { ContactDetailsInvoicePageDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import DataTableWrapper from 'modules/finance/components/Invoices/DataTableWrapper'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ContactsDetailsInvoicesPage: React.FC = () => {
  useEffect(() => {
    track(trackingEvents.accounting.viewContactDetailsPage, {
      view: 'invoices',
    })
  }, [])

  const { contactId } = useParams()

  const { data, loading, error } = useQuery(ContactDetailsInvoicePageDocument, {
    variables: {
      id: String(contactId),
    },
  })

  const contact = data?.finance?.contact

  const canSeeContacts = data?.finance._policies.contactsSee.can ?? false
  const canManagePurchaseFinancialDocuments =
    data?.finance._policies.financialDocumentsManagePurchase.can ?? false
  const canCreatePurchaseFinancialDocuments =
    data?.finance?._policies?.financialDocumentsCreatePurchase?.can ?? false

  const currencies = data ? data.apiCore.currenciesConnection.edges.map((edge) => edge.node) : []
  const legalEntitiesOptions =
    data?.companies.legalEntitiesConnection.nodes.map((legalEntity) => ({
      label: legalEntity.legalName || '',
      value: legalEntity.id,
    })) || []
  const financialDocumentsPaymentsAvailable =
    data?.companies.featureAvailability?.available ?? false

  return (
    <ResponsivePage.Body
      authorized={canSeeContacts && canManagePurchaseFinancialDocuments}
      error={error}
      loading={loading}
      variant="full"
    >
      <Box paddingTop="s24">
        <DataTableWrapper
          vendor={contact || undefined}
          currencies={currencies}
          financialDocumentsPaymentsAvailable={financialDocumentsPaymentsAvailable}
          legalEntities={legalEntitiesOptions}
          canCreatePurchaseFinancialDocuments={canCreatePurchaseFinancialDocuments}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default ContactsDetailsInvoicesPage
